import { Form, TextField } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';

const PaymentDetailsForm: React.FunctionComponent = () => {
  const { formatMessage } = useIntl();
  return (
    <Form.Section label={formatMessage({ id: 'provider.onboarding.form.billing.title' })}>
      <Form.Field
        name="iban"
        label={formatMessage({ id: 'provider.onboarding.form.billing.iban' })}
        required
      >
        <TextField />
      </Form.Field>
      <Form.Field
        name="identificationNumber"
        label={formatMessage({ id: 'provider.onboarding.form.billing.ico' })}
        required
      >
        <TextField />
      </Form.Field>
      <Form.Field
        name="taxIdentificationNumber"
        label={formatMessage({ id: 'provider.onboarding.form.billing.dic' })}
        required
      >
        <TextField />
      </Form.Field>
      <Form.Field
        name="valueAddedTaxIdentificationNumber"
        label={formatMessage({ id: 'provider.onboarding.form.billing.icdph' })}
      >
        <TextField />
      </Form.Field>
    </Form.Section>
  );
};

export default PaymentDetailsForm;
